/** Shared Material React Table styling driven by the active MUI theme. */

export const getMrtContainerProps = (maxHeight = "65vh") => ({
  sx: {
    maxHeight,
    minHeight: maxHeight,
    overflowY: "auto",
    border: "1px solid",
    borderColor: "divider",
    borderRadius: "12px",
    bgcolor: "background.paper",
  },
});

export const getMrtPaperProps = () => ({
  elevation: 0,
  sx: {
    borderRadius: "12px",
    overflow: "hidden",
    bgcolor: "background.paper",
  },
});

export const getMrtHeadCellProps = () => ({
  sx: {
    fontWeight: 700,
    bgcolor: "var(--app-table-header)",
    color: "text.secondary",
    borderBottom: "1px solid",
    borderColor: "divider",
  },
});

const getStripeRowBg = (row) =>
  row.index % 2 === 0 ? "var(--app-surface)" : "var(--app-table-row-alt)";

/** Row sx that wins over global MuiTableRow nth-of-type striping. */
export const getMrtBodyRowSx = (row, { cursor = "pointer", backgroundColor } = {}) => {
  const rowBg = backgroundColor ?? getStripeRowBg(row);

  return {
    cursor,
    "&, &:nth-of-type(even), &:nth-of-type(odd)": {
      backgroundColor: rowBg,
    },
    "& .MuiTableCell-root": {
      backgroundColor: "inherit",
      color: "var(--app-text)",
    },
    "&:hover": {
      "&, &:nth-of-type(even), &:nth-of-type(odd)": {
        backgroundColor: "var(--app-table-row-hover)",
      },
      "& .MuiTableCell-root": {
        backgroundColor: "inherit",
      },
    },
  };
};

export const getMrtTableThemeProps = (options = {}) => ({
  muiTableContainerProps: getMrtContainerProps(options.maxHeight),
  muiTablePaperProps: getMrtPaperProps(),
  muiTableHeadCellProps: getMrtHeadCellProps(),
  muiTableBodyCellProps: {
    sx: { color: "text.primary", borderColor: "divider" },
  },
});
